import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CommonDialog from "../../common/commonDialog";
import moment from "moment";
import { formatMoney } from "../../../constants/utils";
import {
  agingReportFutureODProvPartyWiseDetail,
  agingReportFutureODProvPartyWiseHeader,
} from "../../common/commonConstant";
import CommonTable from "../../common/commonTable";

const FutureOverdueAsmInputModal = (props) => {
  const {
    listData,
    open,
    onCancel,
    title,
    setCustomerRowData,
    setOpenSaveModal,
  } = props;

  const openSaveModalForAsm = (row) => {
    console.log(row, "row openSaveModalForAsm");
    setCustomerRowData(row);
    setOpenSaveModal(true);
  };

  return (
    <>
      <CommonDialog
        onCancel={onCancel}
        onSave={() => {}}
        open={open}
        //primaryButtonLabel={"Submit"}
        title={title}
        maxWidth="lg"
      >
        <CommonTable
          tableData={listData}
          tableHeaders={agingReportFutureODProvPartyWiseHeader}
          tableColumns={agingReportFutureODProvPartyWiseDetail}
          editId={"customerCode"}
          editMode={true}
          onOpenModal={openSaveModalForAsm}
          rowsPerPageOptions={[25, 50, 100]}
          count={listData.length}
          sx={{ float: "right" }}
          displayPagination={false}
        />
      </CommonDialog>
    </>
  );
};

export default FutureOverdueAsmInputModal;
